import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { translate } from "react-switch-lang";
import { Col, Collapse, Row } from "reactstrap";
import Image from "../../../assets/images/training-path/image-landing-page.jpg";
import { DisplayMode } from "../../../models/displayModeDto";
import { TrainingPathDto } from "../../../models/trainingPathDto";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { RootState } from "../../../store";
import PaginationComponent from "../../dashboard/training-path/components/pagination";
import TrainingPath from "../../dashboard/training-path/trainingPath";
import styles from "./landing-page.module.scss";

const LandingPage: React.FC<{ t: any }> = ({ t }) => {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [isOpen7, setIsOpen7] = useState(false);
  const [isOpen8, setIsOpen8] = useState(false);
  const [isOpen9, setIsOpen9] = useState(false);
  const [isOpen10, setIsOpen10] = useState(false);
  const [isOpen11, setIsOpen11] = useState(false);

  const QUESTIONS_ITEMS = [
    {
      id: "question1",
      question: "landing_page.q1quation",
      response: "landing_page.q1response",
      state: isOpen1,
      setState: setIsOpen1,
    },
    {
      question: "landing_page.q2quation",
      response: "landing_page.q2response",
      state: isOpen2,
      setState: setIsOpen2,
    },
    {
      question: "landing_page.q3quation",
      response: "landing_page.q3response",
      state: isOpen3,
      setState: setIsOpen3,
    },
    {
      question: "landing_page.q4quation",
      response: "landing_page.q4response",
      state: isOpen4,
      setState: setIsOpen4,
    },
    {
      question: "landing_page.q5quation",
      response: "landing_page.q5response",
      state: isOpen5,
      setState: setIsOpen5,
    },
    {
      question: "landing_page.q6quation",
      response: "landing_page.q6response",
      state: isOpen6,
      setState: setIsOpen6,
    },
    {
      question: "landing_page.q7quation",
      response: "landing_page.q7response",
      state: isOpen7,
      setState: setIsOpen7,
    },
    {
      question: "landing_page.q8quation",
      response: "landing_page.q8response",
      state: isOpen8,
      setState: setIsOpen8,
    },
    {
      question: "landing_page.q9quation",
      response: "landing_page.q9response",
      state: isOpen9,
      setState: setIsOpen9,
    },
    {
      question: "landing_page.q10quation",
      response: "landing_page.q10response",
      state: isOpen10,
      setState: setIsOpen10,
    },
    {
      question: "landing_page.q11quation",
      response: "landing_page.q11response",
      state: isOpen11,
      setState: setIsOpen11,
    },
  ];

  const { keycloak } = useKeycloak();
  const [traingPathList, setTrainingPathList] = useState<TrainingPathDto[]>([]);
  const currentLang = useSelector((state: RootState) => state.language.currentLang);
  const httpClient = useHttpClient(keycloak.authenticated);
  const [currentPage, setCurrentPage] = useState(0);
  const [trainingPathsPerPage] = useState(8);
  const [pageNumbers, setPageNumbers] = useState(0);

  const paginate = (index: number, e: any) => {
    e.preventDefault();
    setCurrentPage(index);
    getTrainingPathList(index);
  };

  useEffect(() => {
    getTrainingPathList(currentPage);
    // eslint-disable-next-line
  }, [currentLang]);

  const getTrainingPathList = (index: number) => {
    httpClient.current?.get(`/trainingPath/perPage`, { params: { page: index, size: trainingPathsPerPage, language: currentLang.toUpperCase(), archived: false } }).then(response => {
      setTrainingPathList(response?.data?.content as TrainingPathDto[]);
      setPageNumbers(response?.data?.totalPages);
    });
  };

  return (
    <Row>
      <Col md={12}>
        {/* Traing Path List Section */}
        <Col md={12}>
          <div className={styles["training-homepage-title"]}>
            <h2 className={styles["homepage-title"]}>{t("discover_our_online_training")}</h2>
            <br />
          </div>
          <div className={styles["training-path-list-wrapper"]}>
            {traingPathList.map(trainingPath => (
              <TrainingPath key={trainingPath?.id} displayMode={DisplayMode.GALLERY} trainingPath={trainingPath} />
            ))}
          </div>
        </Col>
        {traingPathList.length > 8 && (
          <Col sm="12">
            <PaginationComponent pageNumbers={pageNumbers} paginate={paginate} currentPage={currentPage}></PaginationComponent>
          </Col>
        )}

        {/* Text & Image Section */}
        <Row>
          <Col md={12}>
            <div className={styles["landingpage-buttom-cover"]}>
              <div className={styles["cover-text-image__wrapper"]}>
                <div className={styles["cover-text-image__text"]}>
                  <h3>{t("title_landing_page")}</h3>
                  <h5>{t("landing_page.label_it_is")}</h5>
                  <p style={{ fontSize: "18px" }} className="m-b-0">
                    {t("landing_page.first_paragraph")}
                  </p>
                  <p style={{ fontSize: "18px" }} className="m-b-0">
                    {t("landing_page.second_paragraph")}
                  </p>
                  <p style={{ fontSize: "18px" }}>{t("landing_page.third_paragraph")}</p>
                  <h5>{t("landing_page.for")}</h5>
                  <p style={{ fontSize: "18px" }}>{t("landing_page.paragraph_four")}</p>
                </div>
                <img className={styles["cover-text-image__image"]} src={Image} alt="cover-text" />
              </div>
            </div>
          </Col>
        </Row>

        {/* Questions Section */}
        <Row>
          <Col md={12}>
            <div className={styles["questions-homepage-title"]}>
              <h2 className={styles["homepage-title"]}>{t("frequently_asked_questions")}</h2>
            </div>
            <div className={styles["questions-wrapper"]}>
              <div className={styles["questions-row"]}>
                {QUESTIONS_ITEMS.map(
                  ({ id, question, response, state, setState }, index) =>
                    index < QUESTIONS_ITEMS.length / 2 && (
                      <div className={styles["questions-card"]} key={index}>
                        <div className={styles["questions-card-header"]}>
                          <h6 className={styles["questions-card-header-title"]} onClick={() => setState(!state)}>
                            {t(question)}
                          </h6>
                          {state && <i onClick={() => setState(!state)} className={`${styles["questions-card-header-icon"]} fa fa-minus-square`}></i>}
                          {!state && <i onClick={() => setState(!state)} className={`${styles["questions-card-header-icon"]} fa fa-plus-square`}></i>}
                        </div>
                        <Collapse isOpen={state}>
                          <hr />
                          <div className={styles["questions-card-body"]} style={{ textAlign: "justify", whiteSpace: "pre-wrap" }}>
                            {t(response)}
                          </div>
                        </Collapse>
                      </div>
                    ),
                )}
              </div>

              <div className={styles["questions-row"]}>
                {QUESTIONS_ITEMS.map(
                  ({ id, question, response, state, setState }, index) =>
                    index >= QUESTIONS_ITEMS.length / 2 && (
                      <div className={styles["questions-card"]} key={"k" + index}>
                        <div className={styles["questions-card-header"]}>
                          <h6 className={styles["questions-card-header-title"]} onClick={() => setState(!state)}>
                            {t(question)}
                          </h6>
                          {state && <i onClick={() => setState(!state)} className={`${styles["questions-card-header-icon"]} fa fa-minus-square`}></i>}
                          {!state && <i onClick={() => setState(!state)} className={`${styles["questions-card-header-icon"]} fa fa-plus-square`}></i>}
                        </div>
                        <Collapse isOpen={state}>
                          <hr />
                          <div className={styles["questions-card-body"]} style={{ textAlign: "justify", whiteSpace: "pre-wrap" }}>
                            {t(response)}
                          </div>
                        </Collapse>
                      </div>
                    ),
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default translate(LandingPage);
